import { ApiBase } from 'utils/api';
import { objectToFormData } from 'utils/common';


export default class UtilApi {
    private base: ApiBase;

    constructor(base: ApiBase) {
        this.base = base;
    }

    search = (search: string) => this.base.axios
        .get(`/api/search?s=${search}`)

    searchCar = (chassis: string) => this.base.axios
        .get(`/api/search/car?chassis=${chassis}`)

    sheetColNames = (file: File) => this.base.axios
        .post<string[]>('/api/sheet/col-names',
            objectToFormData({file}),
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

    getSettings = () => this.base.axios
        .get('/api/settings');

    setSettings = (settings: any) => this.base.axios
        .post('/api/settings', {settings});

    pdfPageCount = (file: File) => this.base.axios
        .post<{ count: number }>('/api/pdf/page-count',
            objectToFormData({file}),
            {
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            });

    pdfRotate = (path: string, direction: string) => this.base.axios
        .put(`/api/pdf/rotate`, {}, {params: {path, direction}});

    activityShow = (type: string, id: number) => this.base.axios
        .get(`/api/activity/${type}/${id}`)
        .then(res => res.data);

    activityBatch = (batch: string) => this.base.axios
        .get(`/api/activity/${batch}`)
        .then(res => res.data);

    forceAnshin = () => this.base.axios
        .get('/api/force/anshin')
        .then(res => res.data);
}
